import { render, staticRenderFns } from "./takeoutOrderList.vue?vue&type=template&id=4fc21c17&scoped=true&"
import script from "./takeoutOrderList.vue?vue&type=script&lang=js&"
export * from "./takeoutOrderList.vue?vue&type=script&lang=js&"
import style0 from "./takeoutOrderList.vue?vue&type=style&index=0&id=4fc21c17&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc21c17",
  null
  
)

export default component.exports